import React from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modal';
import { useNavigation } from 'src/contexts/NavigationContext';
import { cn } from 'src/utils/className';

type ContentWrapperProps = {
  children?: React.ReactNode;
  className?: string;
};

export const ContentWrapper = ({
  children,
  className,
}: ContentWrapperProps) => {
  const { showConfirmation, confirmNavigation, cancelNavigation } =
    useNavigation();

  return (
    <>
      <div className={cn('p-6 flex flex-col h-full w-full', className)}>
        {children}
      </div>
      <Modal
        title="Unsaved Changes"
        isOpen={showConfirmation}
        onClose={cancelNavigation}
        closeButtonMessage="Stay"
        actionButton={
          <Button size="small" onClick={confirmNavigation}>
            Leave
          </Button>
        }
      >
        <div className="py-4">
          <p className="text-neutral-600">
            You have unsaved changes. Are you sure you want to leave? Your
            changes will be lost.
          </p>
        </div>
      </Modal>
    </>
  );
};
